<template>
  <div class="cmh-tooltip" :style="style">
    <i18n path="new-connection-cmh.landingPage.tooltip" tag="p">
      <template v-slot:associate>
        <strong>{{ associateName }}</strong>
      </template>
      <template v-slot:partner>
        <strong>{{ partnerName }}</strong>
      </template>
    </i18n>
  </div>
</template>
<style scoped>
.cmh-tooltip {
  position: fixed;
  visibility: hidden;
  opacity: 0;
  width: 265px;
  max-width: 265px;
  background: #494d8d;
  border-radius: .3rem;
  z-index: 99;
  transition: .3s opacity;
  padding: .8rem 1.6rem;
}

.cmh-tooltip p {
  color: #FFFFFF;
  font-size: 1.2rem;
  text-align: center;
}

.cmh-tooltip::before {
  content: "";
  position: absolute;
  top: 100%;
  left: 50%;
  background: #494d8d;
  width: 2rem;
  height: 2rem;
  transform: translate(-50%, calc(-50% - 0.3rem)) rotate(45deg);
  z-index: -1;
}
</style>
<script lang="ts">
import Component from 'vue-class-component'
import { Prop, Vue } from 'vue-property-decorator'

@Component({ name: 'cmh-logo-tooltip' })
export default class CmhLogoToolTip extends Vue {
  @Prop({ type: String, required: true, default: '' }) public partnerId!: string
  @Prop({ type: Function, required: true }) public getTargetRect!: () => DOMRect | null

  private associatePartnerMap = new Map([
    ['scarlet', 'proximus'],
    ['mobile-vikings', 'proximus'],
    ['voo', 'orange']
  ])

  private partnerNamesMap = new Map([
    ['ores', 'Ores'],
    ['swde', 'SWDE'],
    ['resa', 'Resa'],
    ['proximus', 'Proximus'],
    ['scarlet', 'Scarlet'],
    ['mobile-vikings', 'Mobile Vikings'],
    ['orange', 'Orange'],
    ['voo', 'Voo']
  ])

  public get isVisible(): boolean {
    return !!this.associateName
  }

  public get style(): any {
    if (this.isVisible) {
      return {
        left: `${this.position.x}px`,
        top: `${this.position.y}px`,
        'pointer-events': 'none',
        visibility: 'visible',
        'z-index': 100,
        opacity: 1,
      }
    } else {
      return {}
    }
  }

  public get partnerName(): string {
    return this.getPartnerName(this.partnerId)
  }

  public get associateName(): string {
    const associateId = this.associatePartnerMap.get(this.partnerId)
    if (!associateId) {
      return ''
    }
    return this.getPartnerName(associateId)
  }

  get position(): { x: number, y: number } {
    if (!this.getTargetRect) {
      return { x: 0, y: 0 }
    }

    const logoPosition = this.getTargetRect()
    if (!logoPosition) {
      return { x: 0, y: 0 }
    }

    const tooltipRect = this.$el.getBoundingClientRect()
    return {
      x: logoPosition.left - tooltipRect.width / 2 + logoPosition.width / 2,
      y: logoPosition.top - tooltipRect.height - 14 // 14 : bottom triangle height
    }
  }

  getPartnerName(id: string): string {
    return this.partnerNamesMap.get(id) || ''
  }
}
</script>